import React, { useEffect, useState } from "react";
import { Form, Select, Checkbox, Button, message } from "antd";
import API from "../../api";

const { Option } = Select;

export default function ProductSettingForm({ setIsDrawerOpen, fetchSettings }) {
  const [form] = Form.useForm();
  const [stores, setStores] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [userStoreId, setUserStoreId] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  // Get user data from localStorage
  // useEffect(() => {
  //   const storedUser = localStorage.getItem("userData");
  //   if (storedUser) {
  //     const parsedUser = JSON.parse(storedUser);
  //     setUserStoreId(parsedUser?.storeId);
  //     setIsAdmin(parsedUser?.role === "admin");
  //   }
  // }, []);

  // const fetchStores = async () => {
  //   try {
  //     const response = await API.get("/stores");
  //     const storeList = response?.data;
  //     setStores(storeList);

  //     // For non-admins, set the form storeId directly
  //     if (!isAdmin && userStoreId) {
  //       fetchSettingByStore(userStoreId);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching stores:", error);
  //     message.error("Failed to fetch stores.");
  //   }
  // };

  const fetchSettingByStore = async (storeId) => {
    try {
      const res = await API.post("/product/setting/get", { storeId });
      const data = res.data;

      if (data && Object.keys(data).length > 0) {
        form.setFieldsValue({
          storeId: data[0].storeId?._id,
          mfg_exp: data[0].mfg_exp,
          size: data[0].size,
          trackingNumber: data[0].trackingNumber,
          batchNumber: data[0].batchNumber,
        });
        setIsEdit(true);
      } else {
        form.resetFields();
        form.setFieldsValue({ storeId });
        setIsEdit(false);
      }
    } catch (err) {
      console.error("Failed to fetch product setting:", err);
    }
  };

  const handleStoreChange = (value) => {
    fetchSettingByStore(value);
  };

  const handleFinish = async (values) => {
    const payload = {
      storeId: values.storeId,
      // mfg_exp: values.mfg_exp,
      // size: values.size,
      trackingNumber: values.trackingNumber,
      batchNumber: values.batchNumber,
    };

    try {
      const endpoint = isEdit
        ? "/product/setting/update"
        : "/product/setting/create";
      await API.post(endpoint, payload);
      message.success(
        `Product setting ${isEdit ? "updated" : "created"} successfully`
      );
      form.resetFields();
      setIsEdit(false);
      setIsDrawerOpen(false);
      fetchSettings();
    } catch (error) {
      console.error("Error submitting product setting:", error);
      message.error(
        error?.response?.data?.message ||
          `Failed to ${isEdit ? "update" : "create"} product setting`
      );
    }
  };

  // useEffect(() => {
  //   fetchStores();
  // }, [isAdmin, userStoreId]);

  useEffect(() => {
    const init = async () => {
      const storedUser = localStorage.getItem("userData");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        const storeId = parsedUser?.storeId;
        const admin = parsedUser?.role === "admin";

        setUserStoreId(storeId);
        setIsAdmin(admin);

        try {
          const response = await API.get("/stores");
          const storeList = response?.data;
          setStores(storeList);

          if (!admin && storeId) {
            fetchSettingByStore(storeId);
          }
        } catch (error) {
          console.error("Error fetching stores:", error);
          message.error("Failed to fetch stores.");
        }
      }
    };

    init();
  }, []);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={{
        // mfg_exp: false,
        // size: false,
        trackingNumber: false,
        batchNumber: false,
      }}
    >
      <Form.Item
        label="Store Name"
        name="storeId"
        rules={[{ required: true, message: "Please select a store" }]}
      >
        <Select
          placeholder="Select a store"
          onChange={handleStoreChange}
          disabled={!isAdmin}
        >
          {isAdmin
            ? stores.map((store) => (
                <Option key={store?._id} value={store?._id}>
                  {store?.name}
                </Option>
              ))
            : stores
                .filter((store) => store._id === userStoreId)
                .map((store) => (
                  <Option key={store?._id} value={store?._id}>
                    {store?.name}
                  </Option>
                ))}
        </Select>
      </Form.Item>

      {/* <Form.Item name="mfg_exp" valuePropName="checked">
        <Checkbox>Manufacturing & Expiry</Checkbox>
      </Form.Item>

      <Form.Item name="size" valuePropName="checked">
        <Checkbox>Size</Checkbox>
      </Form.Item> */}

      <Form.Item name="trackingNumber" valuePropName="checked">
        <Checkbox>Tracking Number/Eng-No</Checkbox>
      </Form.Item>

      <Form.Item name="batchNumber" valuePropName="checked">
        <Checkbox>Batch Number</Checkbox>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" block>
          {isEdit ? "Update" : "Submit"}
        </Button>
      </Form.Item>
    </Form>
  );
}
